// extracted by mini-css-extract-plugin
export default {"paragraphOne":"ParagraphOne_paragraphOne__6ML1f"};